import { render, staticRenderFns } from "./SecuredMedia.vue?vue&type=template&id=54c4a83a&scoped=true&"
import script from "./SecuredMedia.vue?vue&type=script&lang=js&"
export * from "./SecuredMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c4a83a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/fared/kowamas-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54c4a83a')) {
      api.createRecord('54c4a83a', component.options)
    } else {
      api.reload('54c4a83a', component.options)
    }
    module.hot.accept("./SecuredMedia.vue?vue&type=template&id=54c4a83a&scoped=true&", function () {
      api.rerender('54c4a83a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/widgets/SecuredMedia.vue"
export default component.exports